import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductCard/ProductCard";

const rubikfont = { fontFamily: "Rubik, sans-serif" };

// Layout 1: "Editorial". A cream side panel introduces the collection; the products sit in a grid beside it.
const Layout1 = ({ data }) => {
    const products = (data?.product_id || []).slice(0, 12);
    const navigate = useNavigate();
    const viewAll = () => navigate(`/search?layoutId=${data._id}&title=${encodeURIComponent(data.title)}`);

    return (
        <Box sx={{ py: { xs: 1.5, md: 2.5 } }}>
            <Container maxWidth="xl">
                <Box sx={{ display: "grid", gap: { xs: 2, md: 3 }, gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "260px minmax(0, 1fr)" }, alignItems: "start" }}>
                    {/* Intro panel */}
                    <Box
                        sx={{
                            position: { md: "sticky" },
                            top: { md: 96 },
                            p: { xs: 2.5, md: 3 },
                            borderRadius: "20px",
                            background: "linear-gradient(160deg, #fbf6ea 0%, #fff 70%)",
                            border: "1px solid rgba(200,160,84,0.25)",
                            overflow: "hidden",
                            "&::after": { content: '""', position: "absolute", right: -40, top: -40, width: 120, height: 120, borderRadius: "50%", background: "rgba(200,160,84,0.12)" },
                        }}
                    >
                        <Typography sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "3px", color: "#C8A054", textTransform: "uppercase", mb: 1, ...rubikfont }}>
                            {data?.subtitle || "Exclusive Collection"}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "26px", md: "32px" }, fontWeight: 800, color: "#111", fontFamily: "'Playfair Display', serif", lineHeight: 1.1, mb: 1.5 }}>
                            {data?.title}
                        </Typography>
                        <Box sx={{ width: 40, height: 3, bgcolor: "#C8A054", borderRadius: 2, mb: 1.5 }} />
                        <Typography sx={{ fontSize: "13px", color: "#6b6b6b", mb: 2.5, ...rubikfont }}>
                            {products.length} handpicked {products.length === 1 ? "product" : "products"}
                        </Typography>
                        <Box
                            onClick={viewAll}
                            sx={{ display: "inline-flex", alignItems: "center", gap: 1, px: 2.5, py: 1, borderRadius: "999px", bgcolor: "#111", color: "#fff", fontSize: "12px", fontWeight: 600, letterSpacing: "1.5px", textTransform: "uppercase", cursor: "pointer", transition: "all .2s", "&:hover": { bgcolor: "#C8A054" }, ...rubikfont }}
                        >
                            Explore all →
                        </Box>
                    </Box>

                    {/* Products */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" },
                            gap: { xs: 1.25, sm: 1.5, md: 2 },
                        }}
                    >
                        {products.map((product) => (
                            <Box key={product._id}>
                                <ProductCard product={product} />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Layout1;
